const CREDIT_NOTE_TYPE_ID = 6;
const SALE_TYPE_ID = 8;

const hasCreditNoteAgainstSale = ({ invoiceItems = [], sale }) =>
  sale?.typeId === SALE_TYPE_ID &&
  sale?.instanceId != null &&
  invoiceItems.some(
    item =>
      item?.typeId === CREDIT_NOTE_TYPE_ID &&
      item?.instanceId === sale.instanceId,
  );

export { hasCreditNoteAgainstSale };
